import { api } from './client';

export type DigestSchedule = { day_of_week: number; hour: number };

export function fetchDigestSchedule(): Promise<DigestSchedule> {
  return api.get<DigestSchedule>('/api/digest-schedule');
}

export function updateDigestSchedule(schedule: DigestSchedule): Promise<DigestSchedule> {
  return api.put<DigestSchedule>('/api/digest-schedule', schedule);
}

export type SendDigestNowResult = { ok: boolean; sent: number; reason?: 'not_configured' | 'no_recipients' };

export function sendDigestNow(): Promise<SendDigestNowResult> {
  return api.post<SendDigestNowResult>('/api/digest-schedule/send-now');
}
